import { RMap, useMap } from "maplibre-react-components";
import { useContext, useRef, useState } from "react";
import { ToolsContext, ToolsDispatchContext } from "../../ToolsContext";
import { StopsMl } from "./StopsMl";
import { PopupStopMl } from "./PopupStopMl";
import { ContextMenu } from "primereact/contextmenu";
import { NewStopDialog } from "../stops/NewStopDialog";
import { OverlayContext } from "../../OverlaysContext";
import { RoutesMl } from "./RoutesMl";
import { TripsMl } from "./TripsMl";
import { SegmentsMl } from "./SegmentsMl";


const pks = [17.01604634508332, 54.46720643235502];

export function MapMl(){
    const tool = useContext(ToolsContext);
    const toolDispatch = useContext(ToolsDispatchContext);
    const handleOverlay = useContext(OverlayContext);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [visibleDialog, setVisibleDialog] = useState(false);
    const map = useMap("map-ml");
    const cm = useRef(null);
    let Layers = <></>;

    /** HANDLES */

    const handlePopupClose = () => {
        toolDispatch({
            type: 'changed',
            newTool: {
                ...tool,
                propertyEditor: {
                    ...tool.propertyEditor,
                    popup: false
                }
            }
        });
        return true;
    }

    /** CONTEXT MENU */

    const cmItems = [
        {
          label: 'Utwórz przystanek tutaj',
          icon: 'fa-solid fa-location-dot',
          command: () => {
            setVisibleDialog('newStopDialog');
          }
        },
        {
          label: 'Skopiuj koordynaty',
          icon: 'fa-solid fa-copy',
          command: async () => {
            const locationStr = selectedLocation.lat + ',' + selectedLocation.lng;
            try {
              await navigator.clipboard.writeText(locationStr);
              handleOverlay('toast', {
                severity: "success",
                summary: 'Pozycja skopiowana do schowka',
                detail: locationStr
              })
            } catch (error) {
              handleOverlay('toast', {
                severity: "error",
                summary: 'Kopiowanie nie udało się',
                detail: 'Możesz spróbować skopiować pozycję z tego okienka: \r\n ' + locationStr + '.\r\n Szczegóły błędu: ' + error.message
              })
            }
          }
        }
    ];

    /** ROUTING */

      switch (tool.name) {
        case 'stopsTool':
            Layers = (
                <>
                    <StopsMl />
                    {
                        (tool.propertyEditor && tool.propertyEditor.popup) && <PopupStopMl GStop={tool.propertyEditor.edit} onClose={handlePopupClose}/>
                    }
                </>
            );;
        break;
        case 'routesTool':
            if (tool.propertyEditor) Layers = <RoutesMl />;
        break;
        case 'tripsTool':
            if (tool.propertyEditor) Layers = <TripsMl />
        break;
        case 'segmentsTool':
            Layers = (
                <>
                    <StopsMl />
                    {
                    (tool.selection 
                        && tool.selection.from_stop_id
                        && tool.selection.to_stop_id
                        && tool.selection.route_type
                    ) && <SegmentsMl />
                    }
                </>

            )
        break;
      };



    /** RENDER */

    return (
        <>
            <RMap
                id="map-ml"
                minZoom={6}
                initialCenter={pks}
                initialZoom={17}
                mapStyle="https://openmaptiles.geo.data.gouv.fr/styles/osm-bright/style.json"
                style={{'minHeight': '85vh'}}
                initialClickTolerance={10}
                onContextMenu={ (e) => {
                    console.log('meni',e)
                    if (cm.current) {
                        setSelectedLocation(e.lngLat);
                        cm.current.show(e.originalEvent);
                    }

                } } 
            >
                {Layers}
            </RMap>    
            
            <ContextMenu popup model={cmItems} ref={cm} />
            { selectedLocation &&
                    <NewStopDialog 
                        stopLocation={selectedLocation}
                        visible={(visibleDialog === 'newStopDialog')}
                        onHide={() => {if (!visibleDialog === 'newStopDialog') return; setVisibleDialog(false); }}
                    />
            }    
        </>

    )
}



